import { render } from "./ProfesionalHistorico.vue?vue&type=template&id=532868db&ts=true"
import script from "./ProfesionalHistorico.vue?vue&type=script&lang=ts"
export * from "./ProfesionalHistorico.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__